import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BinariesEffects } from './+state/effects';
import {
  BINARIES_FEATURE_KEY,
  binariesFeatureReducer,
} from './+state/reducers';
import { BinariesService } from './+state/services';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(BINARIES_FEATURE_KEY, binariesFeatureReducer),
    EffectsModule.forFeature([BinariesEffects]),
  ],
  providers: [BinariesService],
})
export class BinariesDataAccessModule {}
